import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ImageType } from './types';
import { readJPEGExifMetaData } from './parseJPEG';
import { readPNGXMPMetaData } from './parsePNG';
import { parseXMPMetaData } from './parsePNGXMP';
export function readImageMetaTags(_x) {
  return _readImageMetaTags.apply(this, arguments);
}
function _readImageMetaTags() {
  _readImageMetaTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var type, _yield$readPNGXMPMeta, iTXt, pHYs, xmpMetaData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          type = file.type;
          _context.prev = 1;
          if (!(type === ImageType.PNG)) {
            _context.next = 12;
            break;
          }
          _context.next = 5;
          return readPNGXMPMetaData(file);
        case 5:
          _yield$readPNGXMPMeta = _context.sent;
          iTXt = _yield$readPNGXMPMeta.iTXt;
          pHYs = _yield$readPNGXMPMeta.pHYs;
          xmpMetaData = _objectSpread(_objectSpread({}, parseXMPMetaData(iTXt)), pHYs);
          return _context.abrupt("return", xmpMetaData);
        case 12:
          if (!(file.type === ImageType.JPEG)) {
            _context.next = 16;
            break;
          }
          _context.next = 15;
          return readJPEGExifMetaData(file);
        case 15:
          return _context.abrupt("return", _context.sent);
        case 16:
          _context.next = 20;
          break;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](1);
        case 20:
          return _context.abrupt("return", null);
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _readImageMetaTags.apply(this, arguments);
}